import React, { CSSProperties } from "react";
import "../../assets/scss/components/generic/tag.scss";

// tag component
export interface TagProps {
	// tags interface
	value: string; //tag value
	shape?: "chip" | "circle" | "mini_circle"; //tag shape
	color: "red" | "green" | "blue" | "yellow"; //tag color
	width?: string; //tag width
	height?: string; //tag height
	tagStyles?: CSSProperties; //tag external Styles if required
	cn?: string;
}

const Tag: React.FC<TagProps> = (props: TagProps) => {
	return (
		// class name depend on shape and color
		// style should be applied only for circle tag
		<i
			className={`ib tag ${props.cn} ${props.value} ${props.shape} ${props.color} ${props.shape ? "bg_" + props.color : "no_bg_chip"}`}
			style={{ height: props.height, width: props.width, ...props.tagStyles }}
		>
			{props.value}
		</i>
	);
};

export default Tag;
